import { render } from "./ImarModalCard.vue?vue&type=template&id=3a1f97c7&scoped=true"
import script from "./ImarModalCard.vue?vue&type=script&lang=js"
export * from "./ImarModalCard.vue?vue&type=script&lang=js"

import "./ImarModalCard.vue?vue&type=style&index=0&id=3a1f97c7&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a1f97c7"]])

export default __exports__